import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { CleanupTenantCommandHandler } from './cleanup-tenant-command-handler.service';
import { SendRegistrationKeyCommandHandler } from './send-registration-key-command-handler.service';
import { PrintGdprCommandHandler } from './print-gdpr-command-handler.service';
import { tenantCommand } from '../../model/const/command';
import { ShowInvoicesCommandHandler } from './show-invoices-command-handler.service';
import { RepayBalanceCommandHandler } from './repay-balance-command-handler.service';
import { ShowFaultNotificationCommandHandler } from './show-fault-notification-command-handler.service';
import { ContactExportCommandHandler } from './contact-export-command-handler.service';
import { MoveBalanceCommandHandler } from './move-balance-command-handler.service';

export abstract class TenantCommandHandlerResolverBase extends CommandHandlerResolver {
  constructor(
    cleanupHandler: CleanupTenantCommandHandler,
    gdprHandler: PrintGdprCommandHandler,
    sendKeyHandler: SendRegistrationKeyCommandHandler,
    showInvoiceHandler: ShowInvoicesCommandHandler,
    repayBalanceHandler: RepayBalanceCommandHandler,
    showFaultNotificationHandler: ShowFaultNotificationCommandHandler,
    exportHandler: ContactExportCommandHandler
  ) {
    super();
    this.addHandler(tenantCommand.cleanupData, cleanupHandler);
    this.addHandler(tenantCommand.printGDPR, gdprHandler);
    this.addHandler(tenantCommand.sendRegistrationKey, sendKeyHandler);
    this.addHandler(tenantCommand.showInvoices, showInvoiceHandler);
    this.addHandler(tenantCommand.repayBalance, repayBalanceHandler);
    this.addHandler(tenantCommand.showFaultNotification, showFaultNotificationHandler);
    this.addHandler(tenantCommand.export, exportHandler);
  }
}
